import { Stream } from '@engoo/realtime-protocol/stream';
import { selectionReducer } from 'app/models/rtc/selection/reducer';
import { tFunctionType } from 'app/services/localization';
import { ILazyDocumentManager, ILazyActionHandler, DummyLazyDocumentManager } from 'app/services/rtc/sync/documentmanagers/lazy';
import { IDocumentSpec } from 'app/services/rtc/sync/DocumentSpec';
import { SharedSelectionDocumentState } from './constants';
import { IEncodedSelectionAction } from '@engoo/realtime-protocol/selection';
import { IDocumentManagerState } from 'app/containers/rtc/DocumentProvider/useDocumentManager';

export type SharedSelectionDocumentManager = ILazyDocumentManager<
  SharedSelectionDocumentState,
  IEncodedSelectionAction
>;

export type SharedSelectionDocumentManagerState = IDocumentManagerState<
  SharedSelectionDocumentState,
  SharedSelectionDocumentManager
>;

export type SharedSelectionDocumentSpec = IDocumentSpec<
  SharedSelectionDocumentState,
  IEncodedSelectionAction,
  ILazyActionHandler<
    SharedSelectionDocumentState,
    IEncodedSelectionAction
  >,
  SharedSelectionDocumentManager
>;

export const makeSharedSelectionDocumentSpec = ({
  managerType,
  actionHandler,
}: Pick<SharedSelectionDocumentSpec, 'managerType' | 'actionHandler'>): SharedSelectionDocumentSpec => ({
  managerType,
  actionHandler,
  initialState: selectionReducer(),
  name: (t: tFunctionType) => t('rtc.features.shared-selection.name'),
});

export const DummySharedSelectionDocumentSpec = makeSharedSelectionDocumentSpec({
  managerType: DummyLazyDocumentManager,
  actionHandler: {
    apply: (state: SharedSelectionDocumentState) => state,
    compress: () => [],
  },
});

export default {
  [Stream.Selection]: DummySharedSelectionDocumentSpec,
};
